import { render, staticRenderFns } from "./TipTapImages.vue?vue&type=template&id=305f9e60&"
import script from "./TipTapImages.vue?vue&type=script&lang=js&"
export * from "./TipTapImages.vue?vue&type=script&lang=js&"
import style0 from "./TipTapImages.vue?vue&type=style&index=0&id=305f9e60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports